var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"12","fill":"#F5F8FB"}}),_c('circle',{attrs:{"xmlns":"http://www.w3.org/2000/svg","cx":"8","cy":"6","r":"3.5","fill":"#DC251C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }